export default {
  "CAN通信接口板卡": "Can通信接口板卡",
  "CMOS类型": "Cmos类型",
  "DCP软件版本": "DCP软件版本",
  "EHUB": "Ehub",
  "ehub下电表": "Ehub下电表",
  "ems": "Ems",
  "excel信息200行内不能有空行数据": "Excel信息200行内不能有空行数据",
  "ICCID卡号": "Iccid卡号",
  "ICCID卡号长度不能超过20": "Iccid卡号长度不能超过20",
  "IMSI码长度不能超过20": "Imsi码长度不能超过20",
  "PCS版本信息": "PCS版本信息",
  "RS485": "Rs485",
  "SMP软件版本": "SMP软件版本",
  "total-items": "共{total}条",
  "V2G": "V2g",
  "三方二维码长度不能大于20": "三方二维码长度不能大于20",
  "上一步": "上一步",
  "上传": "上传",
  "上传图片": "上传图片",
  "上传失败": "上传失败",
  "上传并校验": "上传并校验",
  "上传成功": "上传成功",
  "上传文件": "上传文件",
  "上传文件限制最大值提示语": "文件不能超过{size}mb",
  "上传枪数量至多为200": "上传枪数量至多为200",
  "上传校验失败！": "上传校验失败！",
  "上传校验成功！": "上传校验成功！",
  "上传模板": "上传模板",
  "上传版本": "上传版本",
  "上报时间": "上报时间",
  "上架或发布固件版本提示": "是否{text}该固件版本",
  "删除固件版本提示": "是否删除该固件版本？",
  "上级菜单": "上级菜单",
  "上线时间格式错误": "上线时间格式错误",
  "下一步": "下一步",
  "下发失败": "下发失败",
  "下发成功": "下发成功",
  "下架": "下架",
  "下载失败文档": "下载失败文档",
  "下载模板": "下载模板",
  "不允许输入纯空格": "不允许输入纯空格",
  "不可修改，请谨慎填写，无组织机构代码时，请输入负责人身份证号":
    "不可修改，请谨慎填写，无组织机构代码时，请输入负责人身份证号",
  "不可输入中文": "不可输入中文",
  "不能输入 -": "不能输入 -",
  "专用内部": "专用内部",
  "专用开放": "专用开放",
  "两次密码不一致": "两次密码不一致",
  "个人": "个人",
  "中文按钮名称": "中文按钮名称",
  "中文菜单名称": "中文菜单名称",
  "主板": "主板",
  "事业单位": "事业单位",
  "亚太": "亚太",
  "交流": "交流",
  "交流桩": "交流桩",
  "产品名称长度不能大于50": "产品名称长度不能大于50",
  "产品序列": "产品序列",
  "产品序列与物料编码": "产品序列与物料编码",
  "产品序列号": "产品序列号",
  "产品序列名称": "产品序列名称",
  "产品序列需关联至少一个物料编码": "产品序列需关联至少一个物料编码",
  "人人场站": "人人场站",
  "人员": "人员",
  "物料号": "物料号",
  "仅支持上传2张.png文件，大小不超1mb": "仅支持上传2张.png文件，大小不超1mb",
  "仅支持数字": "仅支持数字",
  "仅支持精准查询": "仅支持精准查询",
  "仅运维": "仅运维",
  "他营": "他营",
  "任务名称": "任务名称",
  "任务状态": "任务状态",
  "任务类型": "任务类型",
  "任务编号": "任务编号",
  "任务范围": "任务范围",
  "任务范围选择": "任务范围选择",
  "任务选择": "任务选择",
  "企业": "企业",
  "企业单位": "企业单位",
  "企业名称": "企业名称",
  "企业法人": "企业法人",
  "企业状态": "企业状态",
  "企业管理": "企业管理",
  "企业类型": "企业类型",
  "企业角色关系": "企业角色关系",
  "保存": "保存",
  "保存后此账户名称为登录账号，密码为初始密码123456":
    "保存后此账户名称为登录账号，密码为初始密码123456",
  "保存后用户名称将被实际使用，建议填写真实姓名":
    "保存后用户名称将被实际使用，建议填写真实姓名",
  "修改": "修改",
  "修改成功": "修改成功",
  "修改状态": "修改状态",
  "修改状态为": "修改状态为",
  "修改配置": "修改配置",
  "储能": "储能",
  "储能中": "储能中",
  "储能计量表": "储能计量表",
  "充满": "充满",
  "充电中": "充电中",
  "充电枪": "充电枪",
  "充电枪型号不能为空": "充电枪型号不能为空",
  "充电枪型号长度不能大于50": "充电枪型号长度不能大于50",
  "充电枪接口标准不能为空或者数据错误": "充电枪接口标准不能为空或者数据错误",
  "充电枪类型和设备类型不对应": "充电枪类型和设备类型不对应",
  "充电枪编号": "充电枪编号",
  "充电枪编号不符合规则": "充电枪编号不符合规则",
  "充电枪编号不能为空": "充电枪编号不能为空",
  "充电枪编号重复": "充电枪编号重复",
  "充电桩": "充电桩",
  "充电模块": "充电模块",
  "光伏": "光伏",
  "光伏设备": "光伏设备",
  "光储一体机": "光储一体机",
  "入户智能电表": "入户智能电表",
  "全部": "全部",
  "全部选择": "全部选择",
  "公共场站": "公共场站",
  "公司员工": "公司员工",
  "公司地址": "公司地址",
  "关系绑定": "关系绑定",
  "最多可选1000场站": "最多可选1000场站",
  "最多可选200场站": "最多可选200场站",
  "最多可选500场站": "最多可选500场站",
  "最多可选中1000台设备": "最多可选中1000台设备",
  "最多可选中200台设备": "最多可选中200台设备",
  "最多可选中500台设备": "最多可选中500台设备",
  "最多输入100字": "最多输入100字",
  "最多输入100字符": "最多输入100字符",
  "最多输入120字": "最多输入120字",
  "最多输入20字符": "最多输入20字符",
  "最大": "最大",
  "最少输入4字符": "最少输入4字符",
  "最新上报时间": "最新上报时间",
  "最新固件版本": "最新固件版本",
  "最新更新": "最新更新",
  "最新版本": "最新版本",
  "最新版本切换提醒": "最新版本切换提醒",
  "最近一次上报时间": "最近一次上报时间",
  "分页总条数": "共计{total}条",
  "创建": "创建",
  "创建人": "创建人",
  "创建任务": "创建任务",
  "创建并执行": "创建并执行",
  "创建时间": "创建时间",
  "初始状态": "初始状态",
  "删除": "删除",
  "删除后，用户无法登录系统，您确定要删除吗":
    "删除后，用户无法登录系统，您确定要删除吗",
  "删除后，用户无法绑定该角色，您确定要删除吗？":
    "删除后，用户无法绑定该角色，您确定要删除吗？",
  "删除成功": "删除成功",
  "刷新": "刷新",
  "加盟直营": "加盟直营",
  "助记码": "助记码",
  "区域": "区域",
  "升级中": "升级中",
  "升级内容": "升级内容",
  "升级前固件版本": "升级前固件版本",
  "升级后固件版本": "升级后固件版本",
  "升级固件版本": "升级固件版本",
  "升级失败": "升级失败",
  "升级成功": "升级成功",
  "升级方式": "升级方式",
  "升级进度": "升级进度",
  "升至最新版本": "升至最新版本",
  "升至指定版本": "升至指定版本",
  "协议标准": "协议标准",
  "原信息": "原信息",
  "发布": "发布",
  "发布人": "发布人",
  "发布时间": "发布时间",
  "发送方式": "发送方式",
  "发送时间": "发送时间",
  "取消": "取消",
  "取消选中": "取消选中",
  "取消选择": "取消选择",
  "变压器数据采集接口板卡": "变压器数据采集接口板卡",
  "合同编号不能为空": "合同编号不能为空",
  "合同编号长度不能超过128": "合同编号长度不能超过128",
  "否": "否",
  "启用": "启用",
  "告警周期": "告警周期",
  "员工姓名": "员工姓名",
  "命令下发失败": "命令下发失败",
  "命令下发成功": "命令下发成功",
  "品牌": "品牌",
  "固件升级": "固件升级",
  "固件号": "固件号",
  "固件号不匹配": "固件号不匹配",
  "固件号为空": "固件号为空",
  "固件版本": "固件版本",
  "固件版本信息": "固件版本信息",
  "国家": "国家",
  "国家代码": "国家代码",
  "国际化标签格式错误": "国际化标签格式错误",
  "图标": "图标",
  "在建中": "在建中",
  "在线预约中": "在线预约中",
  "地区": "地区",
  "地址": "地址",
  "场站名称": "场站名称",
  "场站类型": "场站类型",
  "型号": "型号",
  "基本信息": "基本信息",
  "基础信息": "基础信息",
  "增加“批量升级延时等待”功能，在3小时内请勿重复下发":
    "增加“批量升级延时等待”功能，在3小时内请勿重复下发",
  "备注": "备注",
  "大版本": "大版本",
  "大版本号": "大版本号",
  "失败": "失败",
  "失败原因": "失败原因",
  "姓名": "姓名",
  "子系统信息": "子系统信息",
  "子菜单": "子菜单",
  "字数不能少于10个字": "字数不能少于10个字",
  "字数范围0-210个字": "字数范围0-210个字",
  "字段格式范围": "字段格式范围",
  "存在校验失败数据，无法确认": "存在校验失败数据，无法确认",
  "存在没有关联物料编码的产品序列，请补充":
    "存在没有关联物料编码的产品序列，请补充",
  "安装信息总长度不能超过128": "安装信息总长度不能超过128",
  "安装服务商应输入9位数字或大小写字母": "安装服务商应输入9位数字或大小写字母",
  "安装质保开始日期不能大于结束时间": "安装质保开始日期不能大于结束时间",
  "安装质保开始日期和结束日期必须同时存在":
    "安装质保开始日期和结束日期必须同时存在",
  "安装质保开始结束时间格式错误": "安装质保开始结束时间格式错误",
  "完成创建": "完成创建",
  "定时": "定时",
  "定时执行": "定时执行",
  "客户": "客户",
  "密码重置成功": "密码重置成功",
  "导入户储设备": "导入户储设备",
  "导入结果": "导入结果",
  "导入记录": "导入记录",
  "导入设备": "导入设备",
  "导出": "导出",
  "小版本": "小版本",
  "工号": "工号",
  "已发布": "已发布",
  "已取消": "已取消",
  "已执行": "已执行",
  "已读": "已读",
  "已选择": "已选择",
  "序号": "序号",
  "开始日期": "开始日期",
  "异常数量": "异常数量",
  "当前固件号": "当前固件号",
  "当前固件版本": "当前固件版本",
  "当前固件版本下暂无文件，请重新选择": "当前固件版本下暂无文件，请重新选择",
  "当前版本已是最新版本，若要切换，可设置其他版本为最新版本":
    "当前版本已是最新版本，若要切换，可设置其他版本为最新版本",
  "当前状态": "当前状态",
  "当前硬件类型": "当前硬件类型",
  "当前选中设备": "当前选中设备",
  "必填项不能为纯空格": "必填项不能为纯空格",
  "成功": "成功",
  "成功{susNum}条,失败{failNum}条": "成功{susNum}条，失败{failNum}条",
  "成功数量": "成功数量",
  "我知道了": "我知道了",
  "所属场站": "所属场站",
  "手动": "手动",
  "手机号": "手机号",
  "执行": "执行",
  "执行方式": "执行方式",
  "执行时间": "执行时间",
  "批量修改": "批量修改",
  "批量固件升级校验结果1": "成功{susNum}条,失败0条",
  "批量导入": "批量导入",
  "批量新增": "批量新增",
  "批量新增设备": "批量新增设备",
  "批量新增设备校验结果1": "成功{susNum}条,失败0条",
  "批量新增设备校验结果2": "成功{susNum}条,失败{failNum}条,",
  "批量桩群转移": "批量桩群转移",
  "批量移除": "批量移除",
  "批量选择": "批量选择",
  "按钮": "按钮",
  "排序": "排序",
  "控制拓扑": "控制拓扑",
  "提交": "提交",
  "插枪空闲": "插枪空闲",
  "搜索数量小于1000，可直接选择全部设备":
    "搜索数量小于1000，可直接选择全部设备",
  "搜索数量小于200，可直接选择全部搜索出的设备":
    "搜索数量小于200，可直接选择全部搜索出的设备",
  "搜索数量小于200，可直接选择全部设备": "搜索数量小于200，可直接选择全部设备",
  "搜索数量小于500，可直接选择全部搜索出的设备":
    "搜索数量小于500，可直接选择全部搜索出的设备",
  "操作": "操作",
  "操作人": "操作人",
  "操作成功": "操作成功",
  "操作日志": "操作日志",
  "操作时间": "操作时间",
  "操作桩数量": "操作桩数量",
  "操作类型": "操作类型",
  "操作系统": "操作系统",
  "操作记录": "操作记录",
  "政府部门": "政府部门",
  "故障": "故障",
  "故障名称": "故障名称",
  "故障点": "故障点",
  "故障点编码": "故障点编码",
  "故障码": "故障码",
  "数据包": "数据包",
  "数量": "数量",
  "文件下载": "文件下载",
  "文件名": "文件名",
  "新信息": "新信息",
  "新增固件": "新增固件",
  "新增固件(旧版)": "新增固件(旧版)",
  "新增成功": "新增成功",
  "新增用户": "新增用户",
  "新增角色": "新增角色",
  "新增通知": "新增通知",
  "新密码": "新密码",
  "新建": "新建",
  "新建任务": "新建任务",
  "新建企业": "新建企业",
  "方式": "方式",
  "旧": "旧",
  "时区预览": "时区预览",
  "星充直营": "星充直营",
  "是": "是",
  "是否发版": "是否发版",
  "是否对外发布": "是否对外发布",
  "是否弹窗": "是否弹窗",
  "是否批量移除设备？": "是否批量移除设备？",
  "是否用电表": "是否用电表",
  "是否移除该设备？": "是否移除该设备？",
  "是否设为最新版本？": "是否设为最新版本？",
  "显示排序": "显示排序",
  "普通用户": "普通用户",
  "暂不支持粘贴图片，请从工具栏中上传": "暂不支持粘贴图片，请从工具栏中上传",
  "更多": "更多",
  "更改前场站名称": "更改前场站名称",
  "更改前屏保图片": "更改前屏保图片",
  "更改后场站名称": "更改后场站名称",
  "更改后屏保图片": "更改后屏保图片",
  "更改设备屏保": "更改设备屏保",
  "更新时间": "更新时间",
  "有效版本数": "有效版本数",
  "未发布": "未发布",
  "未执行": "未执行",
  "未查询到与之匹配的目标版本": "未查询到与之匹配的目标版本",
  "未读": "未读",
  "权限标识": "权限标识",
  "条": "条",
  "枪功率大小范围为0~9998": "枪功率大小范围为0~9998",
  "查看": "查看",
  "查看任务": "查看任务",
  "查看角色": "查看角色",
  "查询": "查询",
  "标准不能为空或者数据错误": "标准不能为空或者数据错误",
  "标识权限": "标识权限",
  "校验": "校验",
  "校验失败": "校验失败",
  "校验导入": "校验导入",
  "校验已完成": "校验已完成",
  "校验并创建": "校验并创建",
  "校验成功": "校验成功",
  "校验数量": "校验数量",
  "校验结果": "校验结果",
  "桩配置信息": "桩配置信息",
  "检测存有异常设备": "检测存有异常设备",
  "模板下载": "模板下载",
  "次数": "次数",
  "欧洲": "欧洲",
  "正常": "正常",
  "正常数量": "正常数量",
  "没有改动项": "没有改动项",
  "注：": "注：",
  "注：上传模板前先线下编辑好excel文件，批量新增枪数量不大于200个，超过时建议减少桩数量，分批导入":
    "注：上传模板前先线下编辑好excel文件，批量新增枪数量不大于200个，超过时建议减少桩数量，分批导入",
  "注:此处下载的配置文件里面会标注出异常配置内容":
    "注:此处下载的配置文件里面会标注出异常配置内容",
  "注：点击获取桩群批量转移模版，上传模版前先线下修改好excel表格中对应关系，批量新增桩群对应关系不大于1000个，超过时建议减少桩数量，分批导入":
    "注：点击获取桩群批量转移模版，上传模版前先线下修改好excel表格中对应关系，批量新增桩群对应关系不大于1000个，超过时建议减少桩数量，分批导入",
  "流式传输": "流式传输",
  "流式传输,请选择小于500KB的文件": "流式传输,请选择小于500KB的文件",
  "浏览器": "浏览器",
  "添加": "添加",
  "添加产品序列": "添加产品序列",
  "添加成功": "添加成功",
  "添加文件": "添加文件",
  "添加设备": "添加设备",
  "清空已选设备": "清空已选设备",
  "点击上传": "点击上传",
  "点击获取配置文件下载模板，上传模板前先线下修改好excel配置文件":
    "点击获取配置文件下载模板，上传模板前先线下修改好excel配置文件",
  "版本内容": "版本内容",
  "版本号": "版本号",
  "版本详情": "版本详情",
  "版本说明": "版本说明",
  "物料描述": "物料描述",
  "物料编码": "物料编码",
  "物流单号长度不能超过30": "物流单号长度不能超过30",
  "状态": "状态",
  "生产厂商": "生产厂商",
  "生产厂商不能为空": "生产厂商不能为空",
  "生产厂商应输入9位数字或大小写字母": "生产厂商应输入9位数字或大小写字母",
  "用户名称": "用户名称",
  "用户类型": "用户类型",
  "电压上限不能为空": "电压上限不能为空",
  "电压上限大小范围为0~9999": "电压上限大小范围为0~9999",
  "电压下限不能为空": "电压下限不能为空",
  "电压下限大小范围为0~9999": "电压下限大小范围为0~9999",
  "电池": "电池",
  "电池额定功率（kW）": "电池额定功率（kw）",
  "电池额定容量（kWh）": "电池额定容量（kwh）",
  "电源类型不能为空或者数据错误": "电源类型不能为空或者数据错误",
  "登录IP": "登录ip",
  "登录人员": "登录人员",
  "登录日志": "登录日志",
  "登录时间": "登录时间",
  "监测数据": "监测数据",
  "目标平台": "目标平台",
  "目标版本不能为空": "目标版本不能为空",
  "直流": "直流",
  "硬件SN码": "硬件sn码",
  "硬件信息": "硬件信息",
  "硬件名称": "硬件名称",
  "硬件架构版本号": "硬件架构版本号",
  "硬件类型": "硬件类型",
  "硬件编号": "硬件编号",
  "硬件详情": "硬件详情",
  "确定": "确定",
  "确定启用该角色吗？": "确定启用该角色吗？",
  "确定导入": "确定导入",
  "确定执行此操作吗？": "确定执行此操作吗？",
  "确定禁用该角色吗？": "确定禁用该角色吗？",
  "确认": "确认",
  "确认修改以下": "确认修改以下",
  "确认密码": "确认密码",
  "确认提交后，部分数据存在更新延迟，请在一分钟后前往设备操作日志查看":
    "确认提交后，部分数据存在更新延迟，请在一分钟后前往设备操作日志查看",
  "确认版本号": "确认版本号",
  "确认要删除这条菜单吗": "确认要删除这条菜单吗",
  "确认要远程重启": "确认要远程重启",
  "确认设备": "确认设备",
  "禁用": "禁用",
  "禁用后，用户无法登录系统，您确定要禁用吗":
    "禁用后，用户无法登录系统，您确定要禁用吗",
  "禁用后企业下所有账号将无法使用，是否禁用?":
    "禁用后企业下所有账号将无法使用，是否禁用?",
  "禁用或启用固件版本提示": "是否{status}该固件版本",
  "离线": "离线",
  "离线启动": "离线启动",
  "私桩": "私桩",
  "私桩场站": "私桩场站",
  "移除": "移除",
  "税号": "税号",
  "税号类别": "税号类别",
  "空闲": "空闲",
  "立即执行": "立即执行",
  "端口": "端口",
  "签收信息总长度不能超过128": "签收信息总长度不能超过128",
  "签署日期不能为空": "签署日期不能为空",
  "类型": "类型",
  "系统": "系统",
  "组织机构代码": "组织机构代码",
  "绑定成功": "绑定成功",
  "结束日期": "结束日期",
  "续保开始时间": "续保开始时间",
  "续保时间": "续保时间",
  "续保结束时间": "续保结束时间",
  "维护中": "维护中",
  "编辑": "编辑",
  "编辑固件": "编辑固件",
  "编辑物料编码": "编辑物料编码",
  "编辑用户": "编辑用户",
  "编辑角色": "编辑角色",
  "美洲": "美洲",
  "联营": "联营",
  "能源控制器": "能源控制器",
  "能源设备信息": "能源设备信息",
  "自定义升级": "自定义升级",
  "若迁移成功，由于数据存在更新延迟，请一分钟后在列表刷新查看":
    "若迁移成功，由于数据存在更新延迟，请一分钟后在列表刷新查看",
  "英文按钮名称": "英文按钮名称",
  "英文菜单名称": "英文菜单名称",
  "获取最新配置": "获取最新配置",
  "获取设备当前版本": "获取设备当前版本",
  "获取配置文件": "获取配置文件",
  "菜单": "菜单",
  "菜单权限": "菜单权限",
  "菜单状态": "菜单状态",
  "菜单类型": "菜单类型",
  "蓝牙模块": "蓝牙模块",
  "角色名称": "角色名称",
  "角色绑定": "角色绑定",
  "设备SN码": "设备sn码",
  "设备SN码重复": "设备sn码重复",
  "设备SN码长度不能大于20": "设备sn码长度不能大于20",
  "设备上下线时间不能为空": "设备上下线时间不能为空",
  "设备不在线": "设备不在线",
  "设备不存在": "设备不存在",
  "设备不支持当前选择的模板": "设备不支持当前选择的模板",
  "设备二维码格式必须是8位数字": "设备二维码格式必须是8位数字",
  "设备制造商": "设备制造商",
  "设备名称": "设备名称",
  "设备型号": "设备型号",
  "设备型号不能为空": "设备型号不能为空",
  "设备型号长度不能大于50": "设备型号长度不能大于50",
  "设备对象": "设备对象",
  "设备所有者不能为空": "设备所有者不能为空",
  "设备所有者应输入9位数字或大小写字母": "设备所有者应输入9位数字或大小写字母",
  "设备状态": "设备状态",
  "设备端配置": "设备端配置",
  "设备类型": "设备类型",
  "设备类型不能为空或者数据错误": "设备类型不能为空或者数据错误",
  "设备编号": "设备编号",
  "设备编号不能为空": "设备编号不能为空",
  "设备编号重复": "设备编号重复",
  "设备编码": "设备编码",
  "设备运维方": "设备运维方",
  "设备运维方不能为空或者数据错误": "设备运维方不能为空或者数据错误",
  "设备运营方不能为空": "设备运营方不能为空",
  "设备运营方应输入9位数字或大小写字母": "设备运营方应输入9位数字或大小写字母",
  "设备额定功率不能为空": "设备额定功率不能为空",
  "设备额定功率大小范围为0~9998": "设备额定功率大小范围为0~9998",
  "设置屏保": "设置屏保",
  "该用户没有菜单权限": "该用户没有菜单权限",
  "该账户在用户中心已存在": "该账户在用户中心已存在",
  "详情": "详情",
  "详细地址": "详细地址",
  "详细地址长度不能超过200": "详细地址长度不能超过200",
  "说明": "说明",
  "请上传文件": "请上传文件",
  "请上传模板": "请上传模板",
  "请上传添加Excel表格": "请上传添加excel表格",
  "请上传符合标准的文件": "请上传符合标准的文件",
  "请导入设备": "请导入设备",
  "请求上传失败": "请求上传失败",
  "请求地址": "请求地址",
  "请添加产品序列": "请添加产品序列",
  "请添加数量小于100的Excel表格": "请添加数量小于100的excel表格",
  "请添加数量小于200的Excel表格": "请添加数量小于200的excel表格",
  "请输入": "请输入",
  "请输入，限100字": "请输入，限100字",
  "请输入100字符以内": "请输入100字符以内",
  "请输入20字以内的用户名称": "请输入20字以内的用户名称",
  "请输入20字以内的账户名称": "请输入20字以内的账户名称",
  "请输入300字以内": "请输入300字以内",
  "请输入6-18位密码！": "请输入6-18位密码！",
  "请输入7-18位手机号": "请输入7-18位手机号",
  "请输入9位数字或大小写字母的组织机构代码":
    "请输入9位数字或大小写字母的组织机构代码",
  "请输入中文按钮名称": "请输入中文按钮名称",
  "请输入中文菜单名称": "请输入中文菜单名称",
  "请输入任务名称": "请输入任务名称",
  "请输入企业名称": "请输入企业名称",
  "请输入企业状态": "请输入企业状态",
  "请输入固件号": "请输入固件号",
  "请输入备注内容": "请输入备注内容",
  "请输入字母/数字两种类型的组合！": "请输入字母/数字两种类型的组合！",
  "请输入权限标识": "请输入权限标识",
  "请输入组织机构代码": "请输入组织机构代码",
  "请输入英文按钮名称": "请输入英文按钮名称",
  "请输入英文菜单名称": "请输入英文菜单名称",
  "请输入角色名称": "请输入角色名称",
  "请输入详细地址": "请输入详细地址",
  "请输入负责人姓名": "请输入负责人姓名",
  "请输入负责人电话": "请输入负责人电话",
  "请输入负责人身份证号": "请输入负责人身份证号",
  "请输入账户名称": "请输入账户名称",
  "请输入路由地址": "请输入路由地址",
  "请选择": "请选择",
  "请选择任务类型": "请选择任务类型",
  "请选择企业": "请选择企业",
  "请选择企业类型": "请选择企业类型",
  "请选择升级方式": "请选择升级方式",
  "请选择发送方式": "请选择发送方式",
  "请选择员工": "请选择员工",
  "请选择固件号": "请选择固件号",
  "请选择固件号及固件版本": "请选择固件号及固件版本",
  "请选择固件版本": "请选择固件版本",
  "请选择国家!": "请选择国家!",
  "请选择国家代码": "请选择国家代码",
  "请选择地区": "请选择地区",
  "请选择地区!": "请选择地区!",
  "请选择执行的任务类型": "请选择执行的任务类型",
  "请选择是否弹窗": "请选择是否弹窗",
  "请选择目标平台": "请选择目标平台",
  "请选择硬件类型": "请选择硬件类型",
  "请选择菜单类型": "请选择菜单类型",
  "请选择设备": "请选择设备",
  "请选择设备以及配置": "请选择设备以及配置",
  "请选择设备修改后的状态": "请选择设备修改后的状态",
  "请选择设备对象": "请选择设备对象",
  "请选择设备类型": "请选择设备类型",
  "请选择通知对象": "请选择通知对象",
  "请选择需升级的固件号": "请选择需升级的固件号",
  "请选择需升级的固件版本": "请选择需升级的固件版本",
  "调试信息总长度不能超过128": "调试信息总长度不能超过128",
  "负责人姓名": "负责人姓名",
  "负责人电话": "负责人电话",
  "负责人身份证号": "负责人身份证号",
  "负载电表": "负载电表",
  "账户名称": "账户名称",
  "质保信息": "质保信息",
  "质保到期": "质保到期",
  "质保开始不能大于结束时间": "质保开始不能大于结束时间",
  "质保开始时间": "质保开始时间",
  "质保开始结束时间不能为空": "质保开始结束时间不能为空",
  "质保开始结束时间格式错误": "质保开始结束时间格式错误",
  "质保时间": "质保时间",
  "质保结束时间": "质保结束时间",
  "资源链接": "资源链接",
  "路由地址": "路由地址",
  "身份证号不正确": "身份证号不正确",
  "车位占用": "车位占用",
  "软件平台版本号": "软件平台版本号",
  "软件文件命名规则下载": "软件文件命名规则下载",
  "软件逻辑版本号": "软件逻辑版本号",
  "辅助电压不能为空": "辅助电压不能为空",
  "辅助电压大小范围为0~9999": "辅助电压大小范围为0~9999",
  "输入输出接口板卡": "输入输出接口板卡",
  "迁移": "迁移",
  "运维": "运维",
  "运维-私桩": "运维-私桩",
  "运维-非私桩": "运维-非私桩",
  "运维等级": "运维等级",
  "运营": "运营",
  "运营-人人场站": "运营-人人场站",
  "运营-他营": "运营-他营",
  "运营-加盟直营": "运营-加盟直营",
  "运营-星充直营": "运营-星充直营",
  "运营-联营": "运营-联营",
  "运营归属": "运营归属",
  "运营类型": "运营类型",
  "运行版本信息": "运行版本信息",
  "返回上一步会清空当前页面数据， 是否确定返回上一步?":
    "返回上一步会清空当前页面数据， 是否确定返回上一步?",
  "远程重启": "远程重启",
  "逆变器": "逆变器",
  "选择": "选择",
  "选择产品序列": "选择产品序列",
  "选择人员": "选择人员",
  "选择场站": "选择场站",
  "选择客户": "选择客户",
  "选择文件": "选择文件",
  "选择设备": "选择设备",
  "选择通知对象": "选择通知对象",
  "通信拓扑": "通信拓扑",
  "通知内容": "通知内容",
  "通知对象": "通知对象",
  "通知标题": "通知标题",
  "通讯地址": "通讯地址",
  "通讯棒": "通讯棒",
  "邮箱": "邮箱",
  "邮箱格式不正确": "邮箱格式不正确",
  "部分校验成功，是否继续": "部分校验成功，是否继续",
  "配置下载": "配置下载",
  "配置信息": "配置信息",
  "配置修改": "配置修改",
  "配置内容": "配置内容",
  "配置内容不能为空！": "配置内容不能为空！",
  "配置最新上报时间": "配置最新上报时间",
  "配置最新下发修改时间": "配置最新下发修改时间",
  "配置最新变更时间": "配置最新变更时间",
  "配置刷新": "配置刷新",
  "配置名称": "配置名称",
  "配置字段": "配置字段",
  "配置导出": "配置导出",
  "配置文件版本号": "配置文件版本号",
  "配置文件设备数量不大于200个，超过时建议减少桩数量，分批修改":
    "配置文件设备数量不大于200个，超过时建议减少桩数量，分批修改",
  "配置选择": "配置选择",
  "重新上传": "重新上传",
  "重置": "重置",
  "重置后，密码将恢复默认，您确定要重置吗？":
    "重置后，密码将恢复默认，您确定要重置吗？",
  "重置密码": "重置密码",
  "链接": "链接",
  "销售合同总长度不能超过128": "销售合同总长度不能超过128",
  "销售渠道不能为空或者数据错误": "销售渠道不能为空或者数据错误",
  "锁定状态不允许充电": "锁定状态不允许充电",
  "错误信息": "错误信息",
  "阅读情况": "阅读情况",
  "隐藏": "隐藏",
  "零件信息": "零件信息",
  "非私桩": "非私桩",
  "项参数吗？": "项参数吗？",
  "项目编号不能为空": "项目编号不能为空",
  "项目编号长度不能超过32": "项目编号长度不能超过32",
  "预约等待充电中": "预约等待充电中",
  "预览": "预览",
  "高压": "高压",
  "默认为ftp升级打开后为流式升级(此按钮不打开不支持TCP升级)":
    "默认为ftp升级打开后为流式升级(此按钮不打开不支持TCP升级)",
  "充电桩编号": "充电桩编号",
  "系统将自动录入信息，处理结果将以飞书方式发送给您！": "系统将自动录入信息，处理结果将以飞书方式发送给您！",
};
